export default {
  meta: {
    title: '基于人群画像找位置'
  }
};
